import React from 'react';

const BookIcon: React.FC = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.667 12.875a1.667 1.667 0 0 1 1.666-1.667h9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.333 1.208h9v13.334h-9a1.667 1.667 0 0 1-1.666-1.667v-10a1.667 1.667 0 0 1 1.666-1.667v0Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BookIcon;
